import { render, staticRenderFns } from "./EditOrganization.vue?vue&type=template&id=4800ea44&scoped=true&"
import script from "./EditOrganization.vue?vue&type=script&lang=js&"
export * from "./EditOrganization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4800ea44",
  null
  
)

export default component.exports